<!--<nida-web-card headline="Archive">-->
<dx-button
  *ngIf="loaded"
  (onClick)="submitForm()"
  text="{{ archived ? ('Move to archive' | transloco) : ('Move to live' | transloco) }}"
  type="default"
  [disabled]="disabledArchive"
></dx-button>
